export const DEFAULT_FILTER = {
  save: false,
  title: '',
  only_me: false,
  hitters: [],
  runners: [],
  upClubs: [],
  stadions: [],
  spClubs: [],
  outfielders: [],
  madeOutPlayers: [],
  referees: [],
  game_ids: [],
  vedottu_vaara: ['all'],
  vvo: ['all'],
  was_wrong: ['all'],
  wrong_type: ['all'],
  bases_state: ['all'],
  marked: ['all'],
  hit_outcome: ['all'],
  outs: ['all'],
  hit_number: ['all'],
  vuoropari: ['all'],
  jakso: ['all'],
  lopettava_vuoro: ['all'],
  hit_type: ['all'],
  outfield_formation: ['all'],
  lapilyonti: ['all'],
  tall_pitch: ['all'],
  hitter_side: ['all'],
  kotari: ['all'],
  superi: ['all'],
  vaara_alla: ['all'],
  play_outcome: ['all'],
  mark_type: ['all'],
  run_measured: ['all'],
  folderIds: []
}

export const buildFilterUrl = overrides => {
  const filter = { ...DEFAULT_FILTER, ...overrides }
  return `${window.location.origin}/#/filter/nosave?filter=${encodeURIComponent(JSON.stringify(filter))}`
}
